import { createSlice } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import getAlarmTypesCases from "./cases/get-alarm-types.cases";

type AlarmState = customerPortal.alarms.AlarmState;

const initialState: AlarmState = {
  alarmsTypes: [],
  isLoadingAlarmTypes: false
};

const alarmsSlice = createSlice({
  name: "alarms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getAlarmTypesCases(builder);
  }
});

export default alarmsSlice.reducer;
